var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8636 8.48303H18.4205L13.4318 0.534995C13.3279 0.370319 13.1875 0.235389 13.023 0.142093C12.8585 0.0487976 12.675 0 12.4886 0C12.3023 0 12.1188 0.0487976 11.9543 0.142093C11.7898 0.235389 11.6494 0.370319 11.5455 0.534995L6.55682 8.48303H1.13636C0.511364 8.48303 0 9.02742 0 9.69278C0 9.80166 0.0113636 9.91054 0.0454545 10.0194L2.93182 21.2338C3.19318 22.25 4.06818 23 5.11364 23H19.8864C20.9318 23 21.8068 22.25 22.0795 21.2338L24.9659 10.0194L25 9.69278C25 9.02742 24.4886 8.48303 23.8636 8.48303ZM12.4886 3.39L15.6818 8.48303H9.29545L12.4886 3.39ZM12.5 18.161C11.25 18.161 10.2273 17.0722 10.2273 15.7415C10.2273 14.4108 11.25 13.322 12.5 13.322C13.75 13.322 14.7727 14.4108 14.7727 15.7415C14.7727 17.0722 13.75 18.161 12.5 18.161Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartShopping);
export default __webpack_public_path__ + "static/media/start_shopping.ec48db517f0c81e2ecd9d269370dece0.svg";
export { ForwardRef as ReactComponent };